import { useMemo } from 'react';

import useForm from '../../utils/useForm';
import { IMPORT_DOCUMENT_TYPES } from '../../../constants/formOptions';

const useDocumentForm = (onSubmit, importHasNoDocuments) => {
  const fields = useMemo(
    () => [
      {
        title: 'Document Upload',
        isTitleHidden: false,
        fields: [
          {
            title: 'Document',
            name: 'doc',
            type: 'docUploader',
            required: true,
            className: 'col-span-full',
            multiple: false,
            placeholder: importHasNoDocuments
              ? 'Please upload the loan note PDF first'
              : '',
          },
          {
            title: 'Type',
            type: 'select',
            name: 'type',
            isHidden: () => importHasNoDocuments,
            options: IMPORT_DOCUMENT_TYPES,
            required: !importHasNoDocuments,
          },
        ],
      },
    ],
    [importHasNoDocuments]
  );

  return useForm({ fields, onSubmit });
};

export default useDocumentForm;
